import isNil from 'lodash-es/isNil';
import mergeWith from 'lodash-es/mergeWith';
import isObject from 'lodash-es/isObject';
import isArray from 'lodash-es/isArray';

function nilMerge(a: any, b: any) {
    return isNil(a) ? b : a;
}

export function nilMergeDeep(a: any, b: any) {
    if (isObject(a) && !isArray(a)) {
        return mergeWith({}, a, b, nilMergeDeep);
    } else {
        return nilMerge(a, b);
    }
}
